import type { TestIds } from './types';

export const LOGIN_TEST_IDS: TestIds = {
	LOGIN_BUTTON: 'login-button',
	LOGO: 'login-logo',
	INFO_TEXT: 'info-text',
	TITLE: 'title-text',
	EMAIL_INPUT: 'email',
	PASSWORD_INPUT: 'password',
	FORGOT_PASSWORD_BUTTON: 'forgot-password',
	SIGN_IN_BUTTON: 'sign-in-button',
	SIGN_IN_GOOGLE_BUTTON: 'sign-in-google-button',
	CREATE_NEW_ACCOUNT_BUTTON: 'create-new-account',
};
